"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoCompleteNoResultsMessage = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("../../../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AutoCompleteNoResultsMessage = _ref => {
  let {
    autoCompleteInputValue,
    label
  } = _ref;
  if (!autoCompleteInputValue) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "noResultsFoundMessage"
  }, "No results found. Check your spelling or try a different search.");
};
exports.AutoCompleteNoResultsMessage = AutoCompleteNoResultsMessage;
AutoCompleteNoResultsMessage.propTypes = {
  autoCompleteInputValue: _propTypes.default.string,
  label: _propTypes.default.string
};